module.exports = __webpack_public_path__ + "static/img/head.bce3d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/head.jpg
// module id = flky
// module chunks = 22